module.exports = __webpack_public_path__ + "339b9a884353d3ee05ae9d33f41ec4cd.jpg";